@if (!!url) { @if (hasTag) {
<av-tooltip class="tag-tooltip" position="right" [message]="tagLabel">
  <div
    class="tag"
    data-tid="snapshot/tag"
    [ngStyle]="{ 'background-color': tagColor }"
  ></div>
</av-tooltip>
}
<img
  #snap
  [src]="url"
  [class.hidden]="failed()"
  (error)="imageError()"
  (load)="imageLoaded()"
  alt="{{ 'snapshot' | translate }}"
  crossOrigin="anonymous"
/>
@if (active()) {
<button
  [attr.aria-label]="'Remove snapshot' | translate"
  class="remove"
  avButton
  color="basic"
  size="xxs"
  ofType="icon"
  (click)="remove()"
  data-tid="snapshot/remove"
>
  <av-icon class="trash" name="trash"></av-icon>
</button>
} } @if (isLoading()) {
<av-spinner class="loader" size="xs"></av-spinner>
} @if (isApproved) {
<div
  [attr.aria-label]="'Approved snapshot' | translate"
  class="notification notification-success hidden"
>
  <av-icon data-tid="snapshot/approved" name="tick-round"></av-icon>
</div>
} @if (failed()) {
<div
  [attr.aria-label]="'Snapshot failed to load' | translate"
  class="notification notification-error"
>
  <av-tooltip message="Snapshot failed to load">
    <av-icon mode="light" name="alert" size="xs"></av-icon>
  </av-tooltip>
</div>
}
